// Companion/blocks/SetResultBlock.tsx
//
// What the student did while they were away (ORA-677): a server-written row
// added to the thread when they come back from a study set.
//
// It is drawn as a quiet line rather than a card on purpose. It is not content
// the turn served — it is the conversation noting what happened — so it gets no
// chrome, no header and no share of the per-turn block cap.
//
// The line itself is `setResultText`, shared with the set a student folds away
// in the thread (ORA-833), so the two cannot word the same thing differently.

import { CheckCircle, PauseCircle } from '@phosphor-icons/react';
import type { ChatSetResultBlockPayload } from '@/types/chatBlocks';
import { isSetComplete, setResultText } from './setResultText';

const SetResultBlock = ({
  payload,
}: {
  payload: ChatSetResultBlockPayload;
}) => {
  const Icon = isSetComplete(payload) ? CheckCircle : PauseCircle;

  return (
    // No vertical padding: the thread's own `gap-4` is the whole space around
    // this row, so anything here reads as a wider gap than the thread keeps
    // between any other two rows (Kevin, 2026-09-18).
    <p
      className="m-0 flex items-center gap-1.5 px-1 text-xs text-fg-secondary"
      data-testid="set-result-line"
      data-set-id={payload.setId}
    >
      <Icon size={14} aria-hidden="true" className="shrink-0" />
      <span className="min-w-0 truncate">{setResultText(payload)}</span>
    </p>
  );
};

export default SetResultBlock;
